class LoadMoreButton extends HTMLElement {
  connectedCallback() {
    if (this.dataset.bound === 'true') return;
    this.dataset.bound = 'true';

    this.button = this.querySelector('button');
    if (!this.button) return;

    this.button.addEventListener('click', () => this.loadMore());
  }

  async loadMore() {
    const nextUrl = this.dataset.nextUrl;
    const sectionId = this.dataset.sectionId;
    if (!nextUrl || !sectionId || this.dataset.loading === 'true') return;

    const grid = document.getElementById('product-grid');
    if (!grid) return;

    this.dataset.loading = 'true';
    this.button.setAttribute('aria-disabled', 'true');
    this.button.classList.add('loading');

    try {
      const url = new URL(nextUrl, window.location.origin);
      url.searchParams.set('section_id', sectionId);

      const response = await fetch(url.toString());
      const responseText = await response.text();
      const html = new DOMParser().parseFromString(responseText, 'text/html');
      const newGrid = html.getElementById('product-grid');
      const newLoadMore = html.querySelector('load-more-button');

      if (!newGrid) return;

      const newItems = Array.from(newGrid.querySelectorAll(':scope > .grid__item'));
      grid
        .querySelectorAll('.product-grid__item--hide-when-2col-orphan')
        .forEach((el) => el.classList.remove('product-grid__item--hide-when-2col-orphan'));

      newItems.forEach((item) => {
        item.classList.remove('product-grid__item--hide-when-2col-orphan');
        item.querySelectorAll('.scroll-trigger').forEach((el) => {
          el.classList.add('scroll-trigger--cancel');
        });
        grid.appendChild(item);
      });

      if (window.CollectionGridDensity) {
        window.CollectionGridDensity.apply();
      }

      if (newLoadMore?.dataset.nextUrl) {
        this.dataset.nextUrl = newLoadMore.dataset.nextUrl;
      } else {
        this.remove();
        return;
      }
    } catch (error) {
      console.error('Load more failed', error);
    } finally {
      this.dataset.loading = 'false';
      if (this.isConnected && this.button) {
        this.button.removeAttribute('aria-disabled');
        this.button.classList.remove('loading');
      }
    }
  }
}

if (!customElements.get('load-more-button')) {
  customElements.define('load-more-button', LoadMoreButton);
}
